import React from "react"
import classNames from "classnames"
import { Controller } from "react-hook-form"
import InputMask from "react-input-mask"
import { ErrorMessage } from "@hookform/error-message"

interface ContactNumberProps {
  name: string
  className?: string
  countryCode: string
  errorMessage: string
  control: any
  errors?: any
}

const maskForCountry = {
  uk: "09999999999",
  ire: "0999999999999",
}

const ContactNumber: React.FC<ContactNumberProps> = ({
  name,
  className,
  countryCode,
  errorMessage,
  errors = {},
  control,
  ...rest
}) => {
  const componentClassName = classNames(
    className,
    `contact-input input input-${name}`
  )

  const cssClasses = classNames({
    "error-input": errors[name],
  })

  const getCountryMask = (country: string) => {
    return country === "+44" ? maskForCountry.uk : maskForCountry.ire
  }

  return (
    <>
      <Controller
        defaultValue=""
        render={(props) => (
          <InputMask
            className={`${componentClassName} ${cssClasses}`}
            id="contactNumber"
            // @ts-ignore:next-line
            maskChar={null}
            placeholder="_ _ _ _ - _ _ _ _ _ _"
            mask={getCountryMask(countryCode)}
            type="text"
            {...props}
          />
        )}
        control={control}
        name="contactNumber"
        rules={{
          required: true,
          maxLength: {
            value: countryCode === "+353" ? 13 : 11,
            message: errorMessage,
          },
          pattern: {
            value:
              countryCode === "+44"
                ? /^((07[0-9]{9})|(0[1-6,8-9][0-9]{9})|(\+([0-9]{9}|[0-9]{12}|[0-9]{15})))$/
                : /^/,
            message: errorMessage,
          },
          validate:
            countryCode === "+353"
              ? {
                  startsWithOneZero: (contactNumber) =>
                    /^(0[1-9][0-9]{6,13})$/.test(contactNumber),
                  repeatsNoMoreThanSevenDigits: (contactNumber) =>
                    /^(?!.*(\d)\1{6}).+$/.test(contactNumber),
                }
              : {
                  startsWithOneZero: () => true,
                },
        }}
      />
      <ErrorMessage className="contact-number-error-input" as="p" errors={errors} name={name} message={errorMessage} />
    </>
  )
}

export { ContactNumber }
